import React from 'react';
import clsx from 'clsx';
import { signOut } from 'next-auth/client';

import { Link } from '@edx/components/link';
import { IconAngleDown } from '@edx/components/icons';
import { useDialog } from '@edx/hooks/use-dialog';
import { Avatar } from '@edx/components/avatar';
import { useViewerQuery } from '@edx/graphql/generated';

export const UserNav: React.FC = () => {
  const { handleShow, handleHide, ref, show } = useDialog();
  const { data, client } = useViewerQuery({ ssr: false });

  if (data?.viewer?.__typename !== 'User') return null;

  const { firstName, lastName, avatarUrl } = data.viewer;

  const handleLogout = async (): Promise<void> => {
    handleHide();
    await client.resetStore();
    await signOut();
  };

  return (
    <div
      className="z-50 cursor-pointer flex items-center space-x-2"
      onMouseEnter={handleShow}
      onMouseLeave={handleHide}
    >
      <div className="relative inline-block text-right">
        <div className="inline-flex items-center">
          <Avatar src={avatarUrl} name={`${firstName} ${lastName}`} className="w-9 h-9" />
          <IconAngleDown className="h-3 text-white" />
        </div>

        <div
          className={clsx('mt-1 origin-top-right absolute right-0 w-40 rounded shadow', show ? 'block' : 'hidden')}
          ref={ref}
        >
          <ul
            className="rounded bg-white shadow-xs divide-y divide-gray-400 p-1"
            role="menu"
            aria-expanded={show}
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <li onClick={handleHide}>
              <Link
                href="/favoritos"
                className="block px-4 py-3 leading-5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none hover:bg-gray-300 hover:text-primary-500 transition duration-150"
              >
                Favoritos
              </Link>
            </li>
            <li onClick={handleHide}>
              <Link
                href="/ajustes/cuenta"
                className="block px-4 py-3 leading-5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none hover:bg-gray-300 hover:text-primary-500 transition duration-150"
              >
                Ajustes
              </Link>
            </li>
            <li onClick={handleLogout}>
              <span className="cursor-pointer block px-4 py-3 leading-5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none hover:bg-gray-300 hover:text-primary-500 transition duration-150">
                Salir
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
